var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.505849 8.14677L14.5165 0.13711C14.8293 -0.0506167 15.2671 -0.0506167 15.5798 0.168398C15.8926 0.387412 16.049 0.762865 15.9864 1.13832L13.9849 14.154C13.8911 14.7798 13.203 15.1865 12.6088 14.9362L8.73087 13.3093L6.79189 15.6558C6.60425 15.8748 6.32279 16 6.01005 16C5.44712 16 5.00928 15.562 5.00928 14.9988V11.7449L0.59967 9.93018C-0.150902 9.6173 -0.21345 8.55352 0.505849 8.14677ZM2.13209 8.92897L5.97877 10.5246L5.9475 10.4934L12.7965 2.82786L2.13209 8.92897ZM12.6088 13.3093L14.0787 3.64134L7.3861 11.1191L12.6088 13.3093Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPaperPlane);
export default __webpack_public_path__ + "static/media/img_paperPlane.070faba90aa7e877ceb1559e293b30f8.svg";
export { ForwardRef as ReactComponent };